"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordion = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ri = require("react-icons/ri");

var _framerMotion = require("framer-motion");

var _ = require("../");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      title = _ref.title;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_.View, null, /*#__PURE__*/_react["default"].createElement(_.View, {
    isOpen: isOpen,
    title: "Customize status codes",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    },
    extend: buttonCSS,
    as: "button",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "medium"
  }, title), /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: iconCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    as: _framerMotion.motion.div,
    extend: {
      position: 'absolute'
    },
    animate: {
      opacity: isOpen ? 0 : 1,
      rotate: isOpen ? 40 : 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_ri.RiAddLine, {
    size: 24
  })), /*#__PURE__*/_react["default"].createElement(_.View, {
    as: _framerMotion.motion.div,
    extend: {
      position: 'absolute'
    },
    animate: {
      opacity: isOpen ? 1 : 0,
      rotate: !isOpen ? -40 : 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_ri.RiSubtractLine, {
    size: 24
  })))), /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, {
    initial: false
  }, isOpen && /*#__PURE__*/_react["default"].createElement(_.View, {
    as: _framerMotion.motion.div,
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: 'auto'
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3
    },
    extend: contentCSS
  }, children)));
};

exports.Accordion = Accordion;

var buttonCSS = function buttonCSS(_ref2) {
  var colors = _ref2.theme.colors;
  return {
    border: 'none',
    background: 'none',
    height: 45,
    cursor: 'pointer',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: "1px solid ".concat(colors.border),
    borderBottom: "1px solid ".concat(colors.border),
    // borderRadius: layout.radius,
    // padding: `${grid}px ${2 * grid}px`,
    overflow: 'hidden',
    // color: "white",
    '&:focus': {
      outline: 'none'
    }
  };
};

var iconCSS = function iconCSS() {
  return {
    // background: "hotpink",
    width: 45,
    height: 45,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
};

var contentCSS = function contentCSS(_ref3) {
  var colors = _ref3.theme.colors;
  return {
    borderBottom: "1px solid ".concat(colors.border)
  };
};